export default [
    {
      id: {
        local: '46b9b6ca-f567-420e-b8f9-293dcfc45d64',
        dev: '46b9b6ca-f567-420e-b8f9-293dcfc45d64',
        int: '46b9b6ca-f567-420e-b8f9-293dcfc45d64',
        prod: '628b5ab2-665a-4b8e-b77e-55198b61edf1',
      }, 
      title: 'Device Manager',
      hoverTitle: 'Users with this role have access to transactions, configuration, bulk device, device details and reports pages only',
    },
    {
      id: {
        local: 'a3b17d87-aaf5-4618-9f54-25c14fd7fdd8',
        dev:'a3b17d87-aaf5-4618-9f54-25c14fd7fdd8',
        int: 'a3b17d87-aaf5-4618-9f54-25c14fd7fdd8',
        prod: '14dcc2ba-1ad2-40b6-bccb-9d58876f2392',
      }, 
      title: 'Library Manager',
      hoverTitle: 'Users with this role have access to transactions, configuration, bulk device, and software library management pages only',
    },
    {
      id: {
        local: '437c8562-c104-4bba-b24e-310542337032',
        dev: '437c8562-c104-4bba-b24e-310542337032',
        int: '437c8562-c104-4bba-b24e-310542337032',
        prod: '82a5431f-4f01-4e3d-aeae-d344bd6f7247',
      }, 
      title: 'Administrator',
      hoverTitle: 'Users with this role have access to all pages but limited to partial funcitonality on Admin Page'
    },
    {
      id: {
        local: 'fb3f5de0-5817-4afa-8024-284e160c8a47',
        dev: 'fb3f5de0-5817-4afa-8024-284e160c8a47',
        int: 'fb3f5de0-5817-4afa-8024-284e160c8a47',
        prod: '2022d4bc-718c-4352-80e6-e403a85e22f7',
      }, 
      title: 'Super Administrator',
      hoverTitle: 'Users with this role have access to all pages and functionality'
    },
  ];